import "bootstrap";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import { getAuth, signOut } from "firebase/auth";
import { BrowserRouter, Navigate, Route, Routes, useNavigate, useParams } from "react-router-dom";
import { useSigninCheck } from "reactfire";
import { useMe } from "../hooks/useMe";
import Contact from "../pages/contact-us/contact";
import Home from "../pages/home-page/home";
import Login from "../pages/login/login";
import OurTeam from "../pages/services-pages/our-team";
import "../setup/App.scss";
import Footer from "./footer";
import SiteHeader from "./header";
import PortalHome from "../pages/portal-home/portal-home";
import Drawer from "./drawer";
import ClientSetupContainer from "../pages/clients/client-setup-container";
import ArchivePage from "../pages/archive/archive";
import CaseDetailPage from "../pages/case-detail/case-detail";
import CaseSetupContainer from "../pages/cases/case-setup-container";
import AuthRequred from "../components/auth-required";
import Account from "../pages/portal-home/account";

export default function Router() {
  const { status, data: signInCheckResult } = useSigninCheck();

  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route
            path="/account"
            element={
              <PortalWrapper>
                <Account />
              </PortalWrapper>
            }
          />

          <Route
            path="/secure-portal"
            element={
              <PortalWrapper>
                <PortalHome />
              </PortalWrapper>
            }
          />

          <Route
            path="/client/:id/"
            element={
              <PortalWrapper>
                <ClientSetupContainer />
              </PortalWrapper>
            }
          />

          <Route
            path="/case-form/:id/:page"
            element={
              <PortalWrapper>
                <CaseSetupContainer />
              </PortalWrapper>
            }
          />

          <Route
            path="/case/:id"
            element={
              <PortalWrapper>
                <CaseDetailIndexRedirect />
              </PortalWrapper>
            }
          />

          <Route
            path="/case/:id/:page"
            element={
              <PortalWrapper>
                <CaseDetailPage />
              </PortalWrapper>
            }
          />

          <Route
            path="/admin/:kind/"
            element={
              <PortalWrapper>
                <ArchivePage />
              </PortalWrapper>
            }
          />

          <Route
            path="/contact"
            element={
              <PageWrapper>
                <Contact />
              </PageWrapper>
            }
          />

          <Route
            path="/our-team"
            element={
              <PageWrapper>
                <OurTeam />
              </PageWrapper>
            }
          />

          <Route
            path="/"
            element={
              <PageWrapper>
                <Home />
              </PageWrapper>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

function CaseDetailIndexRedirect() {
  const { id } = useParams();
  return <Navigate to={`/case/${id}/overview`} replace />;
}

const IconSearch = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <circle cx="6" cy="6" r="4.5" stroke="currentColor" strokeWidth="1.4" />
    <path d="M9.5 9.5L13 13" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
  </svg>
);

const PortalTopBar = ({ noAuth }: { noAuth?: boolean }) => {
  const me = useMe();
  const navigate = useNavigate();
  const displayName = [me?.firstName, me?.lastName].filter(Boolean).join(" ").trim();
  const initials = [me?.firstName?.[0], me?.lastName?.[0]].filter(Boolean).join("").toUpperCase();

  const handleSignOut = async () => {
    await signOut(getAuth());
    navigate("/login");
  };

  return (
    <header className="p-topbar">
      <div className="p-search">
        <IconSearch />
        <span>Search cases, clients, documents…</span>
      </div>
      {!noAuth && (
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginLeft: "auto" }}>
          <div className="p-avatar" style={{ width: 36, height: 36, fontSize: 13 }}>{initials || "PT"}</div>
          <div style={{ fontSize: 13 }}>
            <div style={{ fontWeight: 600 }}>{displayName || "User"}</div>
            <div style={{ color: "var(--ink-soft)", fontSize: 11 }}>Greenbelt office</div>
          </div>
          <button
            className="p-btn p-btn-ghost"
            style={{ padding: "8px 12px", fontSize: 12 }}
            onClick={handleSignOut}
          >
            Sign out
          </button>
        </div>
      )}
    </header>
  );
};

const PortalWrapper = ({ children }: { children: any }) => {
  const { data: signInCheckResult } = useSigninCheck();

  if (signInCheckResult && signInCheckResult.signedIn) {
    return (
      <div className="pte-portal">
        <Drawer />
        <div className="p-main">
          <PortalTopBar />
          {children}
        </div>
      </div>
    );
  }

  return (
    <div className="pte-portal">
      <Drawer noAuth={true} />
      <div className="p-main">
        <PortalTopBar noAuth />
        <AuthRequred />
      </div>
    </div>
  );
};

const PageWrapper = ({ children }: { children: any }) => {
  return (
    <div style={{ minHeight: "100vh", background: "var(--paper)" }}>
      <SiteHeader />
      {children}
      <Footer />
    </div>
  );
};
